<template>
  <el-table-column :prop="columnProp" :label="label" v-slot="{ row }" width="200" >
    <template v-if="checkTextOverflow(renderString(row))">
      <el-tooltip :content="renderString(row)" placement="top">
        <span class="overflow-text">{{ truncateText(renderString(row), 10) }}</span>
      </el-tooltip>
    </template>
    <template v-else>
      <span>{{ renderString(row) }}</span>
    </template>
  </el-table-column>
</template>

<script setup name="CusTableColumn">
import { checkTextOverflow, truncateText } from '@/utils/common';

const props = defineProps({
  label: {
    type: String,
    default: '',
  },
  columnProp: {
    type: String,
    default: '',
  },
  content: {
    type: String,
    default: '',
  },
  isTag: {
    type: Boolean,
    default: false,
  },
  companyList: {
    type: Array,
    default: () => [],
  },
  formatString: {
    type: Function,
    default: null,
  },
});
const renderString = (row) => {
  if (props.formatString) {
    return props.formatString(row[props.columnProp]);
  }
  return row[props.columnProp];
};
</script>
